// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_d767fad2","icon":"_fa22714a","text":"_65f7571c","printHide":"_3160ed0"};